var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResidents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2623 24.9002L23.6243 21.6002C23.4815 20.8728 23.0932 20.2165 22.5243 19.7412C22.2089 19.4649 21.8316 19.2686 21.4243 19.1692L18.6633 18.3002C18.6054 18.2813 18.55 18.2554 18.4983 18.2232C18.4247 18.1737 18.3629 18.1086 18.3173 18.0326C18.2717 17.9566 18.2434 17.8714 18.2343 17.7832L18.1133 16.6832C18.9271 16.0208 19.4994 15.1082 19.7413 14.0872C20.2363 14.0872 20.6103 13.4822 20.6103 12.7892C20.6411 12.5199 20.5837 12.2478 20.4469 12.0138C20.3101 11.7798 20.1011 11.5965 19.8513 11.4912",
    stroke: "#C32126",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9865 11.48C11.7367 11.5899 11.5297 11.7782 11.3967 12.0164C11.2637 12.2546 11.212 12.5297 11.2495 12.8C11.2495 13.504 11.6235 14.054 12.1185 14.109C12.3648 15.1251 12.9365 16.0328 13.7465 16.694L13.6255 17.794C13.6142 17.8801 13.5848 17.9628 13.5393 18.0367C13.4938 18.1106 13.4332 18.1741 13.3615 18.223C13.3123 18.2596 13.2561 18.2858 13.1965 18.3L10.4135 19.114C10.008 19.2184 9.6318 19.4141 9.31345 19.686C8.74862 20.1647 8.36119 20.8195 8.21345 21.545L7.56445 24.845",
    stroke: "#C32126",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8299 11.4689C19.8299 11.4689 20.0609 6.79395 15.9249 6.79395C11.7889 6.79395 11.9869 11.4689 11.9869 11.4689",
    stroke: "#C32126",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2725 9.49983C12.4421 9.16177 12.7387 8.90468 13.0975 8.78483C13.6831 8.62591 14.3079 8.70499 14.8355 9.00483C15.5621 9.42635 16.354 9.72377 17.1785 9.88483C17.9732 9.9932 18.7822 9.85901 19.4995 9.49983",
    stroke: "#C32126",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3613 18.2119L15.9243 20.8959",
    stroke: "#C32126",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4878 18.2119L15.9248 20.8959",
    stroke: "#C32126",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9248 20.896V22.667",
    stroke: "#C32126",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9247 5.716C29.8489 8.68546 31.488 12.6859 31.488 16.8535C31.488 21.0211 29.8489 25.0215 26.9247 27.991C25.4908 29.4544 23.7793 30.617 21.8905 31.4107C20.0017 32.2044 17.9735 32.6132 15.9247 32.6132C13.8759 32.6132 11.8477 32.2044 9.95883 31.4107C8.07001 30.617 6.35854 29.4544 4.92468 27.991C2.00041 25.0215 0.361328 21.0211 0.361328 16.8535C0.361328 12.6859 2.00041 8.68546 4.92468 5.716C6.35854 4.25256 8.07001 3.08995 9.95883 2.29626C11.8477 1.50257 13.8759 1.09375 15.9247 1.09375C17.9735 1.09375 20.0017 1.50257 21.8905 2.29626C23.7793 3.08995 25.4908 4.25256 26.9247 5.716V5.716Z",
    stroke: "#C32126",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 35.3061C18.6866 35.2917 21.0154 34.8137 23.1852 33.8993C25.3551 32.9849 27.3236 31.652 28.9783 29.9769C30.6331 28.3017 31.9417 26.317 32.8294 24.1361C33.7171 21.9551 34.1665 19.6207 34.152 17.2661",
    stroke: "#C32126",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3015 28.4751L38.6175 36.8901C39.0044 37.2831 39.2213 37.8126 39.2213 38.3641C39.2213 38.9156 39.0044 39.4451 38.6175 39.8381V39.8381C38.23 40.223 37.7061 40.439 37.16 40.439C36.6138 40.439 36.0899 40.223 35.7025 39.8381L27.3975 31.4121",
    stroke: "#C32126",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidents);
export default __webpack_public_path__ + "static/media/residents.340d7b90e41e5277f5c86ff326c8ffdf.svg";
export { ForwardRef as ReactComponent };